import angular from 'angular';
import DialogController from './dialog.controller';

import _ from './dialog.style.scss';

export default angular.module('autoboard.abDialog', [])
  .directive('abDialog', function ($timeout) {
    'ngInject';

    return {
      controller: DialogController,
      restrict: 'E',
      transclude: true,
      scope: {
        exit: '&', // function to be called when user exits dialog
        confirm: '&?', // optional, function to be called when user confirms dialog
        exitLabel: '@?', // optional
        confirmLabel: '@?', // optional
        title: '@?' // optional
      },
      templateUrl: require('./dialog.template.html')
    }
  })
  .name;